<div class="atn-ds-toggle-button">
  <div
    [class]="[
      'atn-ds-toggle-button__slider',
      activeSg() ? 'atn-ds-toggle-button__slider--checked' : '',
      disabledSg() ? 'atn-ds-toggle-button__slider--disabled' : '',
    ]"
    (click)="!disabledSg() && this.activeSg.set(!this.activeSg())"
  ></div>
  @if (labelSg()) {
    <div class="atn-ds-toggle-button__label">
      {{ labelSg() }}
    </div>
  }
</div>
